import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import css from './tt-page.pcss';

import '@polymer/app-layout'
import '@polymer/iron-image'

export default class TTPage extends LitElement {

    static get styles() {
        return [css];
    }

    render() {
        return html`
<app-header-layout>
    <div id="container">
        <app-header id="header">
            <slot name="header"></slot>
        </app-header>

        <div id="content" role="content">
            <slot name="body"></slot>
        </div>

        <footer id="footer">
            <iron-image id="footerTop" sizing="contain" src=${this.bgURL()}>
            </iron-image>
            <div id="footerContent">
                <iron-image style="width:70px; height:40px;" sizing="contain" src=${this.logoURL()}>
                </iron-image>
            </div>
        </footer>
    </div>
</app-header-layout>

`;
    }

    logoURL() {
        return `${SOURCE.publicPath}assets/dttb-logo-white.png`;
    }

    bgURL() {
        return `${SOURCE.publicPath}assets/bg.svg`;
    }

}

window.customElements.define('tt-page', TTPage);
